import {
	fetchFile,
	patch
} from '@common/utils/request.utils'

type AnalyticsApiRequests = {
	increaseVisits: () => Promise<void>
	downloadAnalytics: (startDate: string, endDate: string) => Promise<void>
}

const ANALYTICS_API_URL = '/analytics'

/**
 * Analytics api requests
 */
export const useAnalyticsApi = (): AnalyticsApiRequests => {
	const increaseVisits = () => patch<void>(`${ANALYTICS_API_URL}/visits`, '')

	const downloadAnalytics = (startDate: string, endDate: string) => {
		const params = new URLSearchParams({ startDate, endDate })
		return fetchFile(`${ANALYTICS_API_URL}/download?${params}`)
	}

	return {
		increaseVisits,
		downloadAnalytics
	}
}
